import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ColorFilter } from "~/components/Filters/ColorFilter/ColorFilter";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { addColorFilterValueAction, clearColorFilterValuesAction, removeColorFilterValueAction } from "~/store/filters/actions";
import { hasColorsFiltersValuesSelector, selectedColorsFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleColorFilter = /*#__PURE__*/ memo((param)=>{
    let { colors, onApplyClick } = param;
    const dispatch = useDispatch();
    const hasValues = useAirSelector(hasColorsFiltersValuesSelector);
    const selectedColors = useSelector(selectedColorsFiltersSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    const clearValues = useCallback(()=>{
        dispatch(clearColorFilterValuesAction());
    }, [
        dispatch
    ]);
    const handleColorToggle = useCallback((param)=>{
        let { color, isSelected } = param;
        if (isSelected) {
            dispatch(addColorFilterValueAction({
                color: color.hex
            }));
        } else {
            dispatch(removeColorFilterValueAction({
                color: color.hex
            }));
        }
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "color",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(ColorFilter, {
            colors: colors,
            onClick: handleColorToggle,
            selectedColors: selectedColors.colors
        })
    });
});
SingleColorFilter.displayName = "SingleColorFilter";
